import { getSubmissionFields } from "../utils";
import { getNow } from "../utils";
import Form from "./Form";
import { useDataContext, useUserContext } from "../contexts";
import { ADMIN } from "../constants";

export default function SubmissionAdd({ callback }) {
  const { user } = useUserContext();
  const { memberUsers } = useDataContext();

  const submissionFields = getSubmissionFields(memberUsers, user);

  const userIsAdmin = user.profileType === ADMIN;
  let formUserValue;

  if (userIsAdmin) {
    formUserValue = "";
  } else {
    formUserValue = user.id;
  }

  return (
    <Form
      path="submissions"
      fields={submissionFields}
      submitCallback={callback}
      initialValues={{
        user: formUserValue,
        startDate: getNow(),
      }}
    />
  );
}
